import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { recalculateTotalPrices } from '../../../actions';
import { useProp103Features } from '../../../hooks';

import infoIcon from '../../../assets/plans/info.svg';
import IconTooltip, { TOOL_TIP_POSITION } from '../../common/IconTooltip';

import { SelectorPill } from './SelectorPill';
import styles from './SelectorPills.module.css';

export const SelectorPills = ({
  items = [{ disabled: false, item: {}, value: '' }],
  onChange = () => { },
  position = TOOL_TIP_POSITION.start,
  title,
  tooltipDescription,
  value,
}) => {
  const dispatch = useDispatch();
  const prop103 = useProp103Features();

  const onOptionClick = useCallback((item) => {
    if (item.disabled) {
      return;
    }

    onChange(item);
    dispatch(recalculateTotalPrices());
  }, [dispatch, onChange]);

  const titleForId = title.replace(/\s/g, '-');

  return (
    <fieldset
      className={`${styles.container} ${prop103
        ? styles.containerProp103 : ''}`}
    >
      <span className={styles.title} id={`${titleForId}-label`}>
        <legend className={styles.titleLegend}>{title}</legend>

        {tooltipDescription && (
          <IconTooltip
            backgroundColor="var(--deep-blue-main)"
            containerClassName={styles.tooltipClassName}
            description={tooltipDescription}
            descriptionClassName={styles.descriptionTooltip}
            icon={infoIcon}
            name={title}
            position={position}
          />
        )}
      </span>

      <div
        className={`${styles.options} ${prop103 ? styles.optionsProp103 : ''}`}
      >
        {items.map((item) => (
          <SelectorPill
            key={item.value}
            checked={value.value === item.id}
            disabled={item.disabled}
            itemExtraData={item}
            label={item.value}
            name={title.replace(' ', '')}
            onChange={onOptionClick}
            value={item.id}
          />
        ))}
      </div>
    </fieldset>
  );
};
